/* HoD full-fold system (WP0, 29 Sep 2026). Loaded with `defer` on fold templates only (layout/theme.liquid).
   Does NOT depend on theme.optimized.js (intent-gated on home/collection). Plan §2.4 JS + A3, A20.
   1. Measures #SiteHeader -> --hod-header-h on <html>; measures the fold copy -> --hod-fold-content-h on the fold.
   2. Watches .hod-fold__sentinel (the fold's bottom pixel): once it passes under the header's bottom edge the
      header goes solid (removes .is-light); scrolling back restores the server tone.
   3. Menus (details[open], dropdown hover/focus) and the search drawer force the solid header while open.
   4. No fold on the page (removed in the editor) -> solid header.
   5. In-page links with [data-hod-fold-scroll] (the cue, collection CTA, the PDP rating link) scroll smoothly (instantly
      under reduced motion), then re-measure and correct the landing once the scroll has settled (final fix).
   API:  document event 'hod:fold:tone'   detail {tone:'light'|'dark'}  -> sets the photo tone (hod-pdp-fold.js, A20)
         document event 'hod:fold:header' detail {solid:boolean}        <- fired on every header state change
         window.HodFold.setTone(tone), window.HodFold.update(), window.HodFold.isSolid() */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var wrapper = doc.querySelector('.header-wrapper--fold');
  var header = doc.getElementById('SiteHeader');
  var fold = doc.querySelector('[data-hod-fold]');
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function scrollOpts() { return { behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' }; }

  // ---- fix round 2 (T8): html.hod-fold-ready ends the below-fold content-visibility window (critical CSS) ----
  // Set when the fold photo has loaded, on the first scroll/touch/pointer/key, on an in-page jump, after 4 s, at once
  // when the page opens on a #hash or in the theme editor, and at once when there is no fold.
  var readySet = false;
  function markReady() {
    if (readySet) return;
    readySet = true;
    root.classList.add('hod-fold-ready');
  }
  (function () {
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var fimg = fold ? fold.querySelector('.hod-fold__img') : null;
    if (!fold || !fimg || inEditor || (location.hash && location.hash.length > 1) || fimg.complete) { markReady(); return; }
    fimg.addEventListener('load', markReady, { once: true });
    fimg.addEventListener('error', markReady, { once: true });
    ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown', 'hashchange'].forEach(function (t) {
      window.addEventListener(t, markReady, { once: true, passive: true, capture: true });
    });
    setTimeout(markReady, 4000);
  })();

  // ---- 5. in-page scroll (works on any page that loads this file) ----
  // Fix round 3: listen on WINDOW in the CAPTURE phase, so this runs before any document-level listener (the layout's
  // intent loader, the theme bundle's own anchor handling) and the FIRST tap always scrolls, bundle or not. The event
  // is not stopped: the intent loader still sees it and starts the bundle in the background.
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-hod-fold-scroll]') : null;
    if (!a) return;
    var hash = a.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    // data-hod-fold-target (optional CSS selector) narrows the landing, e.g. the gift card's "Add a message" lands
    // on the main purchase stack rather than the top of the product section (the gallery comes first on phones).
    var sel = a.getAttribute('data-hod-fold-target');
    var target = null;
    if (sel) { try { target = doc.querySelector(sel); } catch (err) { target = null; } }
    if (target && target.getBoundingClientRect().height === 0) target = null;
    if (!target) target = doc.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    markReady();
    jumpTo(target);
    if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      target.setAttribute('tabindex', '-1');
    }
    try { target.focus({ preventScroll: true }); } catch (err) { /* old browsers */ }
  }, true);

  // Final fix (review: on phones the fold rating link landed 480-675px short of #judgeme_product_reviews in 4 of 10
  // taps). theme.css gives the FAQ, collage, specs, related products and the review widget content-visibility:auto with
  // a 1000px placeholder; the browser aimed at the placeholder layout, the sections then rendered at their real height,
  // and phone scroll anchoring did not make up the difference. So: (1) html.hod-fold-jumping renders every section
  // for the duration of the jump (critical CSS), so the first aim is already right; (2) once the scroll has settled,
  // re-measure and correct instantly if the target is more than 2px off the header's bottom edge (up to 3 tries).
  function landingTop() {
    var hh = header ? Math.round(header.getBoundingClientRect().height) : 0;
    var sp = parseFloat(getComputedStyle(root).scrollPaddingTop);
    return isNaN(sp) ? hh : sp;
  }
  function whenSettled(cb) {
    var done = false;
    var last = -1;
    var stable = 0;
    var start = Date.now();
    function finish() { if (done) return; done = true; window.removeEventListener('scrollend', onEnd); cb(); }
    function onEnd() { setTimeout(finish, 60); }
    if ('onscrollend' in window) window.addEventListener('scrollend', onEnd);
    (function poll() {
      if (done) return;
      var y = window.pageYOffset;
      stable = Math.abs(y - last) < 0.5 ? stable + 1 : 0;
      last = y;
      if (stable >= 6 || Date.now() - start > 2500) { finish(); return; }
      requestAnimationFrame(poll);
    })();
  }
  var jumpSeq = 0;
  function jumpTo(target) {
    var seq = ++jumpSeq;
    root.classList.add('hod-fold-jumping');
    void target.getBoundingClientRect(); // lay out the now-rendered sections before aiming
    target.scrollIntoView(scrollOpts());
    var tries = 0;
    (function check() {
      whenSettled(function () {
        if (seq !== jumpSeq) return;
        var off = target.getBoundingClientRect().top - landingTop();
        if (Math.abs(off) > 2 && tries < 3) {
          tries++;
          window.scrollBy({ top: off, left: 0, behavior: 'auto' });
          check();
          return;
        }
        root.classList.remove('hod-fold-jumping');
      });
    })();
  }
  window.addEventListener('wheel', function () { jumpSeq++; root.classList.remove('hod-fold-jumping'); }, { passive: true });
  window.addEventListener('touchstart', function () { jumpSeq++; root.classList.remove('hod-fold-jumping'); }, { passive: true });

  if (!wrapper || !header) return;

  var serverLight = wrapper.classList.contains('is-light');
  var toneLight = serverLight;
  var reasons = { past: false, menu: false, hover: false, search: false, nofold: !fold };
  var headerH = 0;
  var lastSolid = null;

  function isSolid() {
    return !toneLight || reasons.past || reasons.menu || reasons.hover || reasons.search || reasons.nofold;
  }

  function apply() {
    var solid = isSolid();
    wrapper.classList.toggle('is-light', !solid);
    wrapper.classList.toggle('header-wrapper--fold-solid', solid);
    // Fix round 1: the Inbox launcher is lifted above the fold copy on phones only while the fold is in view.
    // Fix round 2: the launcher is restyled (ghost ring in the corner) on every fold, the quiet one included.
    root.classList.toggle('hod-fold-chat-lift', !!fold && !reasons.past);
    if (solid !== lastSolid) {
      lastSolid = solid;
      doc.dispatchEvent(new CustomEvent('hod:fold:header', { detail: { solid: solid } }));
    }
  }

  // ---- 2. sentinel ----
  var sentinel = null;
  if (fold) {
    sentinel = fold.querySelector('.hod-fold__sentinel');
    if (!sentinel) {
      sentinel = doc.createElement('span');
      sentinel.className = 'hod-fold__sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;left:0;right:0;bottom:0;height:1px;pointer-events:none;opacity:0';
      if (getComputedStyle(fold).position === 'static') fold.style.position = 'relative';
      fold.appendChild(sentinel);
    }
  }

  function checkPast() {
    if (!sentinel) return;
    // Solid once the fold's bottom edge is at or above the header's bottom edge (T4: fold bottom = headerH - 1 ->
    // solid, headerH + 1 -> photo tone). Exact equality counts as solid, so an anchor that lands right under the
    // fold (the cue, the collection CTA, #MainProduct) never leaves a transparent header over white.
    var top = sentinel.getBoundingClientRect().top;
    var past = top < (headerH || header.offsetHeight) - 0.5;
    if (past !== reasons.past) { reasons.past = past; apply(); }
  }

  var io = null;
  function observe() {
    if (!sentinel || !('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(checkPast, { rootMargin: '-' + Math.max(0, headerH) + 'px 0px 0px 0px', threshold: [0, 1] });
    io.observe(sentinel);
  }

  // rootMargin is ignored for the implicit root inside a cross-origin iframe (theme editor), and very old
  // browsers lack IO: fall back to a rAF-throttled passive scroll check there.
  var inFrame = false;
  try { inFrame = window.self !== window.top; } catch (err) { inFrame = true; }
  if (sentinel && (inFrame || !('IntersectionObserver' in window))) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; checkPast(); });
    }, { passive: true });
  }

  // ---- 1. measurements ----
  function measureHeader() {
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0 && h !== headerH) {
      headerH = h;
      root.style.setProperty('--hod-header-h', h + 'px');
      observe();
      if (typeof observeExit === 'function' && exitIo) observeExit();
      checkPast();
    }
  }
  var inner = fold ? fold.querySelector('.hod-fold__inner') : null;
  function measureContent() {
    if (!inner || !fold) return;
    var fr = fold.getBoundingClientRect();
    var ir = inner.getBoundingClientRect();
    var h = Math.max(0, Math.round(fr.bottom - ir.top));
    fold.style.setProperty('--hod-fold-content-h', h + 'px');
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () { measureHeader(); measureContent(); });
    ro.observe(header);
    if (inner) ro.observe(inner);
    if (fold) ro.observe(fold);
  } else {
    window.addEventListener('resize', function () { measureHeader(); measureContent(); });
  }
  measureHeader();
  measureContent();
  window.addEventListener('resize', measureContent, { passive: true });

  // ---- fix round 1: .is-scrolled shows the header's own band once the page moves (at rest the fold paints it) ----
  var scrolled = null;
  function syncScrolled() {
    var s = (window.pageYOffset || root.scrollTop || 0) > 4;
    if (s !== scrolled) { scrolled = s; wrapper.classList.toggle('is-scrolled', s); }
  }
  var sTick = false;
  window.addEventListener('scroll', function () {
    if (sTick) return;
    sTick = true;
    requestAnimationFrame(function () { sTick = false; syncScrolled(); });
  }, { passive: true });
  syncScrolled();

  // ---- fix round 1: fold copy fades before it reaches the header (fallback for browsers without view timelines;
  // assets/hod-fold.css does it with animation-timeline:view() elsewhere) ----
  var viewTimeline = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));
  var exitIo = null;
  function observeExit() {
    if (viewTimeline || !fold || !('IntersectionObserver' in window)) return;
    var lines = fold.querySelectorAll('.hod-fold__inner > :not(.hod-fold-buy), .hod-fold-buy > :not(.visually-hidden)');
    if (!lines.length) return;
    if (exitIo) exitIo.disconnect();
    // final fix: the same 56px exit gap as the CSS view timeline (0 on short landscape)
    var inset = (headerH || header.offsetHeight) + (window.innerHeight > 520 ? 56 : 0);
    exitIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var rb = en.rootBounds;
        var under = !!rb && en.boundingClientRect.top < rb.top - 0.5;
        en.target.classList.toggle('is-under-header', under);
      });
    }, { rootMargin: '-' + inset + 'px 0px 0px 0px', threshold: [0, 1] });
    Array.prototype.forEach.call(lines, function (el) { exitIo.observe(el); });
  }
  observeExit();

  // ---- 3. menus, dropdown hover, search drawer ----
  function syncMenu() {
    reasons.menu = !!wrapper.querySelector('details[open]');
    apply();
  }
  wrapper.addEventListener('toggle', syncMenu, true);
  var dropdowns = wrapper.querySelectorAll('.site-nav--has-dropdown');
  Array.prototype.forEach.call(dropdowns, function (item) {
    item.addEventListener('mouseenter', function () { reasons.hover = true; apply(); });
    item.addEventListener('mouseleave', function () { reasons.hover = false; apply(); });
  });
  wrapper.addEventListener('focusin', function (e) {
    reasons.hover = !!(e.target.closest && e.target.closest('.site-nav--has-dropdown'));
    apply();
  });
  wrapper.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!wrapper.contains(doc.activeElement)) { reasons.hover = false; apply(); }
    }, 0);
  });
  function syncSearch() {
    var open = root.classList.contains('js-drawer-open--search');
    if (open !== reasons.search) { reasons.search = open; apply(); }
  }
  if ('MutationObserver' in window) {
    new MutationObserver(syncSearch).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  // ---- A20: tone updates from the PDP image swap ----
  function setTone(tone) {
    toneLight = tone !== 'dark';
    apply();
  }
  doc.addEventListener('hod:fold:tone', function (e) { setTone(e.detail && e.detail.tone); });

  window.HodFold = {
    setTone: setTone,
    update: function () { measureHeader(); measureContent(); checkPast(); syncMenu(); syncSearch(); },
    isSolid: isSolid
  };

  // First pass also handles scroll restoration on reload.
  checkPast();
  syncMenu();
  syncSearch();
  apply();
})();
